<template>
  <component :is="component" />
</template>

<script>
import IconAudience1stGroup from "@/components/icon/audience/1stGroup"
import IconAudience2ndGroup from "@/components/icon/audience/2ndGroup"
import IconAudience3rdGroup from "@/components/icon/audience/3rdGroup"

export default {
  components: {
    IconAudience1stGroup,
    IconAudience2ndGroup,
    IconAudience3rdGroup,
  },
  props: {
    n: { type: Number, default: 3 },
  },
  computed: {
    component() {
      switch (this.n) {
        case 1:
          return "icon-audience-1st-group"
        case 2:
          return "icon-audience-2nd-group"
        default:
          return "icon-audience-3rd-group"
      }
    },
  },
}
</script>
